export enum KnmResultDecisionStatusEnum {
  COMPLETED = 'RESOLVED',
  NOT_COMPLETED = 'NOT_RESOLVED',
  CANCELED = 'CANCELED',
}
